import { lazy } from "react";
import ScreenURL from "./route_list";

export const auth_route = [
  {
    path: ScreenURL.LOGIN,
    element: lazy(() => import("src/screens/auth/SignInScreen")),
  },
];

export const service_paths = [
  {
    path: ScreenURL.MANAGE_CLIENT,
    element: lazy(() => import("src/screens/client/ManageClientScreen")),
  },
  {
    path: ScreenURL.MANAGE_WORKSPACE,
    element: lazy(() => import("src/screens/workspace/ManageWorkspaceScreen")),
  },
  {
    path: ScreenURL.MANAGE_ORGANIZATION,
    element: lazy(
      () => import("src/screens/organization/ManageOrganizationScreen")
    ),
  },
  {
    path: ScreenURL.MANAGE_ORGANIZATION_ADMIN,
    element: lazy(
      () => import("src/screens/organization/ManageOrganizationAdminScreen")
    ),
  },
  {
    path: ScreenURL.MANAGE_INSTITUTION,
    element: lazy(
      () => import("src/screens/institution/ManageInstitutionScreen")
    ),
  },
  {
    path: ScreenURL.MANAGE_INSTITUTION_CREATE,
    element: lazy(
      () => import("src/screens/institution/CreateInstitutionScreen")
    ),
  },
  {
    path: ScreenURL.WORKSPACE_CREATE,
    element: lazy(
      () => import("src/screens/workspace/WorkspaceConfigurationScreen")
    ),
  },
  {
    path: ScreenURL.WORKSPACE_EDIT,
    element: lazy(
      () => import("src/screens/workspace/WorkspaceConfigurationScreen")
    ),
  },

  {
    path: ScreenURL.ORGANIZATION_CREATE,
    element: lazy(
      () => import("src/screens/organization/OrganizationConfigurationScreen")
    ),
  },
  {
    path: ScreenURL.ORGANIZATION_EDIT,
    element: lazy(
      () => import("src/screens/organization/OrganizationConfigurationScreen")
    ),
  },
  {
    path: ScreenURL.NOTICE,
    element: lazy(() => import("src/screens/notice/index")),
  },
  {
    path: ScreenURL.NOTICE_WRITE,
    element: lazy(() => import("src/screens/notice/index")),
  },
  {
    path: ScreenURL.NOTICE_EDIT,
    element: lazy(() => import("src/screens/notice/index")),
  },
  {
    path: ScreenURL.NOTICE_DETAIL,
    element: lazy(() => import("src/screens/notice/index")),
  },
  {
    path: ScreenURL.CREATE_PAYMENT_WINDOW,
    element: lazy(
      () => import("src/screens/payment/CreatePaymentWindowScreen")
    ),
  },
  {
    path: ScreenURL.PAYMENT_WINDOW_CREATION_HISTORY,
    element: lazy(
      () => import("src/screens/payment/PaymentWindowCreationHistoryScreen")
    ),
  },
  {
    path: ScreenURL.MANAGE_OAUTH_CLIENT,
    element: lazy(() => import("src/screens/oauth/ManageOAuthClientScreen")),
  },
  {
    path: ScreenURL.ACCESS,
    element: lazy(() => import("src/screens/legacy/AccessScreen")),
  },
  {
    path: ScreenURL.DASHBOARD,
    element: lazy(() => import("src/screens/legacy/DashBoardScreen2")),
  },
  {
    path: ScreenURL.REPORT_USER_LOG,
    element: lazy(() => import("src/screens/legacy/UserLogScreen")),
  },
];

export const fallback_route = [
  {
    path: "/*",
    element: lazy(() => import("src/screens/common/ForbiddenScreen")),
  },
];
